import axiosClient from './axiosClient';

export const getDashboardStats = () => {
  return axiosClient.get('/admin/dashboard/stats');
};

export const getDashboardCharts = () => {
  return axiosClient.get('/admin/dashboard/charts');
};

export const getRecentActivities = () => {
  return axiosClient.get('/admin/dashboard/recent');
};
